import apiClient from '@/api/client';
import { patientService } from './patientService';
import { appointmentService } from './appointmentService';
import { consultationService } from './consultationService';
import { doctorService } from './doctorService';
import { reportService } from './reportService';
import { authService } from './authService';
import { clinicService } from './clinicService';
import { featureService, DEFAULT_CLINIC_FEATURES } from './featureService';
import { settingsService, DEFAULT_CLINIC_SETTINGS } from './settingsService';
import { HOSPITAL_ID, DEFAULT_CLINIC_ID, getActiveHospitalId, getActiveClinicId } from '@/constants';

import { prescriptionTemplateService } from './prescriptionTemplateService';
import { invoiceService } from './invoiceService';

// Re-export modular services
export {
  patientService,
  appointmentService,
  consultationService,
  doctorService,
  reportService,
  authService,
  clinicService,
  featureService,
  settingsService,
  prescriptionTemplateService,
  invoiceService,
  DEFAULT_CLINIC_FEATURES,
  DEFAULT_CLINIC_SETTINGS,
  apiClient,
};

// Aliases for backward compatibility
export const patientsApi = patientService;
export const appointmentsApi = appointmentService;
export const consultationsApi = consultationService;
export const doctorsApi = doctorService;
export const filesApi = {
  getByPatient: patientService.getDocuments,
  upload: patientService.uploadDocument,
  delete: (id) => patientService.deleteDocument(null, id),
};

export const dashboardApi = {
  /**
   * GET /hospital/{hospitalId}/clinic/{clinicId}/dashboard/stats
   * User identity, role, and permissions are extracted automatically from the Bearer JWT token on the backend.
   */
  getStats: async (clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);
    const res = await apiClient.get(`/hospital/${activeHospId}/clinic/${activeClinicId}/dashboard/stats`);
    const data = res.data || res;
    return {
      ...data,
      recentAppointments: (data.recentAppointments || []).map((a) => ({
        ...a,
        date: a.appointmentDateTime?.split('T')[0] || a.date,
        time: a.appointmentDateTime?.split('T')[1]?.substring(0, 5) || a.time,
      })),
      appointments: (data.appointments || []).map((a) => ({
        ...a,
        date: a.appointmentDateTime?.split('T')[0] || a.date,
        time: a.appointmentDateTime?.split('T')[1]?.substring(0, 5) || a.time,
      })),
    };
  },
};

export default apiClient;
